import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import DeliveryModal from './DeliveryModal'
import {
  hero,
  heroText,
  mobileHero,
  mobileHeroText,
  deliveryButton,
} from 'images'

export default () => {
  const [showModal, setShowModal] = useState(false)
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyStart
        >
          <CFView textCenter column center w="100%" h="90vh">
            <CFView column center>
              <CFImage src={mobileHeroText} w="85%" alt="Promotions" />
            </CFView>
            <CFView mt="30px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView hover onClick={() => setShowModal(true)} column center>
              <CFImage
                mv="10px"
                w="65%"
                maxWidth="=190px"
                src={deliveryButton}
                alt="Order delivery"
              />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
          pl="5%"
        >
          <CFImage w="45%" src={heroText} alt="Promotions" />
          <CFView mt="30px" pulsate>
            <OrderPickupButton />
          </CFView>
          <CFView hover onClick={() => setShowModal(true)} column center>
            <CFImage
              mv="10px"
              w="25vw"
              maxWidth="260px"
              src={deliveryButton}
              alt="Order delivery"
            />
          </CFView>
        </CFView>
      </DefaultScreen>
      <DeliveryModal
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
